import { Pressable, StyleSheet, View } from 'react-native';
import { Marker } from 'react-native-maps';

import { Impact } from '@/api/models/impactModels';
import Text from '@/components/Text';
import { formatCurrency } from '@/utils/currencyFormat';

interface ImpactMarkerProps {
  data: Impact;
  showDonation?: () => void;
}

const ImpactMarker = ({ data, showDonation }: ImpactMarkerProps) => {
  const latAbs = Math.abs(data.latitude);
  const longAbs = Math.abs(data.longitude);

  if (latAbs < 0 || latAbs > 90) {
    console.error('Latitude needs to be between -90 and 90 degress.');
    return null;
  }

  if (longAbs < 0 || longAbs > 180) {
    console.error('Longitude needs to be between -180 and 180 degress.');
    return null;
  }

  return (
    <Marker
      coordinate={{
        latitude: data.latitude,
        longitude: data.longitude
      }}>
      <Pressable
        onPress={() => {
          if (showDonation) showDonation();
        }}>
        <View style={styles.donationPill}>
          <Text style={styles.donationPillText}>{formatCurrency(data.amount)}</Text>
        </View>
      </Pressable>
    </Marker>
  );
};

const styles = StyleSheet.create({
  donationPill: {
    backgroundColor: 'white',
    paddingHorizontal: 7,
    paddingVertical: 5,
    borderRadius: 20,
    borderColor: 'black',
    borderWidth: 1,
    alignSelf: 'center'
  },

  donationPillText: {
    color: 'black',
    fontSize: 14
  }
});

export default ImpactMarker;
